import { Button, Error as ErrorComponent } from "@design-system/components";
import { trackError } from "@error-tracking/client";
import { AlertCircle } from "lucide-react";
import React from "react";

interface AppErrorFallbackProps {
  error: Error;
  reset?: () => void;
}

function AppErrorFallback({ error, reset }: AppErrorFallbackProps) {
  const handleTrackError = (err: Error) => {
    try {
      trackError(err, {
        source: "router-initialization",
        component: "ErrorFallback",
        timestamp: new Date().toISOString(),
        url: window.location.href,
      });
    } catch (trackingError) {
      console.warn("Failed to track error:", trackingError);
    }
  };

  return (
    <div className="bg-background flex min-h-screen items-center justify-center p-4 pb-[20vh]">
      <ErrorComponent
        error={error}
        onTrackError={handleTrackError}
        className="max-w-2xl flex-none border-none"
      >
        <ErrorComponent.Media>
          <AlertCircle />
        </ErrorComponent.Media>
        <ErrorComponent.Header>
          <ErrorComponent.Title>Application Error</ErrorComponent.Title>
          <ErrorComponent.Description>
            We&apos;re sorry, but something went wrong. Please try refreshing
            the page.
          </ErrorComponent.Description>
        </ErrorComponent.Header>
        <ErrorComponent.Actions>
          {reset && (
            <Button variant="emphasised" onClick={reset}>
              Try again
            </Button>
          )}
          <Button variant="default" onClick={() => window.location.reload()}>
            Reload page
          </Button>
        </ErrorComponent.Actions>
        <ErrorComponent.Details error={error} />
      </ErrorComponent>
    </div>
  );
}

export { AppErrorFallback };
